// Page header — back button, title, status badge, and export actions.
import React from 'react';
import { ArrowLeft, ShieldAlert, BookOpen } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { getStatusBadgeClass } from './callDetailUtils';
import WonPill from '../../components/WonPill';
import CallExportActions from './CallExportActions';

const GovernanceBreachChip = ({ reason, violations }) => {
  const label = reason === 'governance_and_score'
    ? 'Governance + Score'
    : 'Governance breach';
  const tip = violations && violations.length
    ? `Governance breach: ${violations.join('; ')}`
    : 'Compliance / trust breach detected — escalated independently of the numeric score';
  return (
    <span
      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-red-100 text-red-700 border border-red-300 text-xs font-semibold whitespace-nowrap"
      title={tip}
      data-testid="governance-breach-chip"
    >
      <ShieldAlert className="w-3.5 h-3.5" /> {label}
    </span>
  );
};

export const CallHeader = ({ call, grading, onBack }) => (
  <div className="flex items-center justify-between flex-wrap gap-3">
    <div className="flex items-center space-x-4 min-w-0">
      <Button
        variant="outline"
        size="icon"
        onClick={onBack}
        data-testid="back-btn"
        className="print:hidden"
      >
        <ArrowLeft className="w-4 h-4" />
      </Button>
      <div className="min-w-0">
        <h1
          className="text-3xl font-bold text-slate-900 flex items-center gap-3"
          style={{ fontFamily: 'Outfit' }}
        >
          Call Details
          {call?.won && (
            <WonPill
              source={call.chase_outcome_source}
              by={call.chase_outcome_by}
              size="sm"
            />
          )}
        </h1>
        <p className="text-slate-600 text-sm break-all">ID: {call.call_id}</p>
      </div>
    </div>
    <div className="flex items-center gap-3 flex-wrap">
      <CallExportActions call={call} grading={grading} />
      {call?.customer_phone && grading?.overall_score != null && (
        <Button
          variant="outline"
          size="sm"
          className="print:hidden border-teal-200 text-teal-700 hover:bg-teal-50 hover:text-teal-800"
          onClick={() => window.dispatchEvent(new CustomEvent('vf-open-playbook'))}
          data-testid="open-playbook-top-btn"
          title="Jump to the callback playbook for this call (generates it if needed)"
        >
          <BookOpen className="w-4 h-4 mr-1.5" /> Open Playbook
        </Button>
      )}
      {call?.governance_breach && (
        <GovernanceBreachChip
          reason={call.escalation_reason}
          violations={grading?.governance_violations}
        />
      )}
      <span className={getStatusBadgeClass(call.status)}>{call.status}</span>
    </div>
  </div>
);
